export default __webpack_public_path__ + "static/media/mel.13bfcda6.JPG";